/**
 * buildQueueJoinPanelLabels — builds the full `QueueJoinPanelLabels` object
 * from a `t()` function scoped to the `reservations` namespace (CU-86cb7ewja).
 * Shared by every `QueueJoinPanel` caller (offer-draft availability tab,
 * inventory catalog, media-unit detail calendar) so the same ~15-key
 * mapping isn't repeated per route.
 */
import type { QueueJoinPanelLabels } from './queue-join-panel';

export function buildQueueJoinPanelLabels(
  t: (key: string, options?: Record<string, unknown>) => string,
): QueueJoinPanelLabels {
  return {
    addAnotherClientLabel: t('waitlist.addAnotherClientLabel'),
    newEntryTitle: t('waitlist.newEntryTitle'),
    cancelLabel: t('waitlist.cancelLabel'),
    clientLabel: t('waitlist.clientLabel'),
    brandLabel: t('waitlist.brandLabel'),
    offerLabel: t('waitlist.offerLabel'),
    clientPlaceholder: t('waitlist.clientPlaceholder'),
    brandPlaceholder: t('waitlist.brandPlaceholder'),
    offerPlaceholder: t('waitlist.offerPlaceholder'),
    clientSearchPlaceholder: t('waitlist.clientSearchPlaceholder'),
    brandSearchPlaceholder: t('waitlist.brandSearchPlaceholder'),
    offerSearchPlaceholder: t('waitlist.offerSearchPlaceholder'),
    brandRequiredLabel: t('waitlist.brandRequiredLabel'),
    noBrandsLabel: t('waitlist.noBrandsLabel'),
    joinLabel: t('waitlist.joinBtn'),
    changeIdentityLabel: t('waitlist.changeIdentityLabel'),
    expiryLabel: t('waitlist.expiryLabel'),
    expiryHint: t('waitlist.expiryHint'),
    queueListLabels: {
      title: t('waitlist.ownEntriesTitle'),
      subtitle: '',
      noOfferLabel: t('labels.noOffer'),
      positionLabel: (position: number) => t('unitTab.queuePositionLabel', { position }),
      spansMultipleLabel: t('unitTab.queueSpansMultiple'),
      ownBadgeLabel: t('unitTab.queueOwnBadge'),
      submittedByLabel: t('unitTab.queueSubmittedBy'),
      leaveLabel: t('waitlist.leaveBtn'),
      removeLabel: t('unitTab.queueRemoveLabel'),
      promoteLabel: t('unitTab.queuePromoteLabel'),
      brandLabel: t('queueOverview.brandLabel'),
    },
  };
}
